import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Tooltip from '../../shared/components/tooltip';

import '../css/loyalty-badge.less';

const LoyaltyBadge = ({ multiplier, userSeg, type }) => {
	return userSeg === 'CG_gs' ? (
        <div className="loyalty-badge">
            <span className="badge-icon"></span>
            { type === 'productCard' && <span className="title">{`Earn ${multiplier}X HP Rewards Points`}</span>}
            <Tooltip 
                className={type === 'productCard' ? 'v2' : ''}
                label={type === 'productCard' ? '?' : `Earn ${multiplier}X HP Rewards Points`}
                displayOn={type === 'productCard' ? 'click' : 'mouseover'}
            >
                <p>
                    HP Rewards is a loyalty program where users earn HP Rewards points by buying eligible HP Products.
                    <br />
                    <a href={`${process.env.BASENAME}/LoadLoyaltyLandingPageCmd?catalogId=10051&userTyp=G&storeId=10151`} target="_blank">Learn more</a>
                </p>
            </Tooltip>
        </div>
	) : null;
};

LoyaltyBadge.defaultProps = {
    type: 'pdp'
}

LoyaltyBadge.propTypes = {
    /*hp reward multiplier from product attributes*/
    multiplier: PropTypes.string.isRequired,
    /*component type*/
    type: PropTypes.oneOf(['pdp', 'productCard'])    
}

const mapStateToProps = (state) => {
    const { userData={} } = state;
    const { profileData={} } = userData;
    const { personData={} } = profileData;

	return {
		userSeg: personData.custSeg
	};
};


export default connect(mapStateToProps, undefined)(LoyaltyBadge);

